import { render, staticRenderFns } from "./cancellation-policy.vue?vue&type=template&id=4d5e410c&scoped=true"
import script from "./cancellation-policy.vue?vue&type=script&lang=js"
export * from "./cancellation-policy.vue?vue&type=script&lang=js"
import style0 from "./cancellation-policy.vue?vue&type=style&index=0&id=4d5e410c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5e410c",
  null
  
)

export default component.exports